import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function TeamContact() {
  return (
    <section className="py-16 bg-background">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <h2 className="text-2xl font-extrabold text-brand-navy mb-4">Team &amp; contact</h2>
        <p className="text-base text-muted-foreground leading-relaxed mb-8">
          LabComplyx is a small operation. We work with a network of laboratory compliance professionals and regulatory specialists. If your engagement requires expertise we don't have in-house, we will tell you, and we will help you find it.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild size="lg" className="bg-brand-teal hover:bg-brand-teal/90 text-white font-semibold">
            <Link to="/validation-intake">Book a Free Compliance Review</Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="border-brand-navy text-brand-navy bg-transparent hover:bg-brand-navy/5 font-semibold">
            <a href="mailto:hello@labcomplyx.com">hello@labcomplyx.com</a>
          </Button>
        </div>
        <p className="mt-8 text-sm text-muted-foreground">
          <strong className="text-brand-navy">LabComplyx Weekly</strong> — newsletter for CLIA/CAP labs navigating compliance documentation.{" "}
          <a
            href="mailto:hello@labcomplyx.com?subject=Subscribe%20to%20LabComplyx%20Weekly"
            className="font-semibold text-brand-teal underline underline-offset-2"
          >
            Subscribe →
          </a>
        </p>
      </div>
    </section>
  );
}